import createAction from '../services/create-action';

export const APPLICATION_DELETED = 'application/DELETED';

export default createAction(APPLICATION_DELETED);



// WEBPACK FOOTER //
// ./app/actions/application-deleted.js